import ContactUsForm from 'components/ContactUs/ContactUsForm';
import useTheme from 'hooks/useTheme';
import Head from 'next/head';

function ContactUs() {
  useTheme({
    light: false,
  });

  return (
    <>
      <Head>
        <title>
          Contact Us: Spirit Labs | Your Software Development Company
        </title>
        <meta
          name="description"
          content="Want to transform your business into digital era? We are here to make your imagination become a real thing. Let's work together!"
        />
      </Head>
      <ContactUsForm />
    </>
  );
}

export default ContactUs;
